const initialState = {
  //@ts-ignore
  profile: null,
  //@ts-ignore
  error: null,
};

const userReducer = (state = initialState, action: any) => {
  switch (action.type) {
    case 'SET_USER_PROFILE':
      return {
        ...state,
        profile: action.payload,
      };
    case 'FETCH_USER_PROFILE_ERROR':
      return {
        ...state,
        error: action.payload,
      };
    default:
      return state;
  }
};

export default userReducer;
